<template>
    <div class="question-container" :class="{ active: isActive }">
        <div class="question-item__question" @click="toggleActive">
            <div class="question-icon">
                <img src="/themes/custom/usturao/img/svg/faq-q.svg" />
            </div>
            <div class="question-text" v-html="question">
                {{ question }}
            </div>
            <div class="accordion-icon">
                <img
                    class="accordion-icon--open"
                    src="/themes/custom/usturao/img/svg/accordion-open.svg"
                    v-if="!isActive"
                />
                <img
                    class="accordion-icon--close"
                    src="/themes/custom/usturao/img/svg/accordion-close.svg"
                    v-else
                />
            </div>
        </div>
        <div
            class="question-item__answer"
            :style="{ maxHeight: `${anwserBoxHeight}px` }"
        >
            <div class="answer-icon">
                <img src="/themes/custom/usturao/img/svg/faq-a.svg" />
            </div>
            <div class="answer-text" ref="answerBox" v-html="answer">
                {{ answer }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuestionCard",
    props: {
        question: String,
        answer: String,
        isAllActive: Boolean,
    },
    data() {
        return {
            isActive: false,
            anwserBoxHeight: 0,
        };
    },
    watch: {
        isAllActive(allActive) {
            allActive ? (this.isActive = true) : (this.isActive = false);
            this.getAnswerTextHeight();
        },
    },
    methods: {
        toggleActive() {
            this.isActive = !this.isActive;
            this.getAnswerTextHeight();
        },
        getAnswerTextHeight() {
            const height = this.$refs.answerBox.clientHeight;

            this.isActive
                ? (this.anwserBoxHeight = height + 30)
                : (this.anwserBoxHeight = 0);
        },
    },
    mounted() {
        if (this.isAllActive) this.toggleActive();
    },
    updated() {
        if (this.isAllActive) this.getAnswerTextHeight();
    },
};
</script>
